import { useOrganization } from '@clerk/clerk-react';

/**
 * Hook to check if the current user has one or more permissions from org membership metadata.
 * @param {string[]} permissionsToCheck - List of permissions, e.g., ['edit_articles', 'delete_articles']
 * @returns {boolean}
 */
export function useHasClerkPermissions(permissionsToCheck: string[]) {
  const { membership, isLoaded } = useOrganization();

  if (!isLoaded || !membership) return false;

  const userPermissions = membership.permissions || [];
  return permissionsToCheck.some((permission) => userPermissions.includes(permission));
}
